import { useForm as useFormHook } from 'react-hook-form';
import type {
  FieldValues,
  UseFormProps as UseFormPropsHook,
} from 'react-hook-form';

export const useForm = <T extends FieldValues>(
  useFormProps?: Omit<UseFormPropsHook<T>, 'mode'>
) => useFormHook<T>({ ...useFormProps, mode: 'all' });
